import { render, staticRenderFns } from "./EnergyInfo.vue?vue&type=template&id=23865de3&scoped=true"
import script from "./EnergyInfo.vue?vue&type=script&lang=js"
export * from "./EnergyInfo.vue?vue&type=script&lang=js"
import style0 from "./EnergyInfo.vue?vue&type=style&index=0&id=23865de3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23865de3",
  null
  
)

export default component.exports